import React from 'react'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

const SkeletonRow = ({ colCount }) => (
  <tr>
    {Array.from({ length: colCount }).map((_, idx) => (
      <td key={idx} className='px-4 py-3'>
        <div className='h-4 w-full rounded-md bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse'></div>
      </td>
    ))}
  </tr>
)

const MuleSoftTable = ({ records, isInitialLoading, statusCode }) => {
  const columns = [
    'Rank',
    'Workday ID',
    'AMS ID',
    'AMS Code',
    'First Name',
    'Middle Name',
    'Last Name',
    'Gender',
    'Age',
    'Distance to Client (miles)',
    'Previously Worked Client',
    'Phone',
    'Email',
    'State',
    'Overnight',
    'Branch Name',
    'Ethnicity',
    'Address Line 1',
    'City',
    'Postal Code'
  ]

  const formatPhone = phone => {
    if (!phone) return '-'
    const phoneNumber = parsePhoneNumberFromString(phone, 'US')
    return phoneNumber ? phoneNumber.formatNational() : phone || '-'
  }

  const rowHeight = 42
  const tableHeight = 600
  const skeletonCount = Math.ceil(tableHeight / rowHeight)

  const showNoData = !isInitialLoading && records.length === 0

  let message = 'No caregivers found'
  if (statusCode === 404) message = 'Client not found (404)'
  else if (statusCode >= 500) message = 'Server error, please try again'

  return (
    <div className='container mx-auto bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden mb-5'>
      <div className='relative overflow-auto max-h-[600px] min-h-[600px]'>
        {showNoData && (
          <div className='absolute inset-0 flex items-center justify-center bg-white z-10'>
            <p className='text-gray-600 font-medium text-lg'>{message}</p>
          </div>
        )}

        <table className='min-w-max border-collapse w-full'>
          <thead className='bg-purple-700 text-white text-sm sticky top-0 z-20 shadow-sm'>
            <tr>
              {columns.map(col => (
                <th
                  key={col}
                  className='px-4 py-3 font-semibold whitespace-nowrap border-b border-purple-600'
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className='text-sm'>
            {isInitialLoading &&
              Array.from({ length: skeletonCount }).map((_, idx) => (
                <SkeletonRow key={idx} colCount={columns.length} />
              ))}

            {!isInitialLoading &&
              records.length > 0 &&
              records.map(record => (
                <tr
                  key={record.enterprise_id}
                  className='hover:bg-gray-50 transition'
                >
                  <td className='px-4 py-2 text-center'>
                    {record.rank ?? '-'}
                  </td>
                  <td className='px-4 py-2'>{record.workday_id || '-'}</td>
                  <td className='px-4 py-2'>{record.ams_id || '-'}</td>
                  <td className='px-4 py-2'>{record.ams_code || '-'}</td>
                  <td className='px-4 py-2'>{record.first_name || '-'}</td>
                  <td className='px-4 py-2'>{record.middle_name || '-'}</td>
                  <td className='px-4 py-2'>{record.last_name || '-'}</td>
                  <td className='px-4 py-2'>{record.gender || '-'}</td>
                  <td className='px-4 py-2 text-center'>{record.age ?? '-'}</td>
                  <td className='px-4 py-2 text-center'>
                    {record.distance_to_client != null
                      ? record.distance_to_client.toFixed(2)
                      : '-'}
                  </td>
                  <td className='px-4 py-2 text-center'>
                    {record.caregiver_previously_worked_with_client === true
                      ? 'Yes'
                      : record.caregiver_previously_worked_with_client === false
                      ? 'No'
                      : '-'}
                  </td>
                  <td className='px-4 py-2'>{formatPhone(record.phone)}</td>
                  <td className='px-4 py-2'>{record.email || '-'}</td>
                  <td className='px-4 py-2'>{record.state || '-'}</td>
                  <td className='px-4 py-2 text-center'>
                    {record.overnight ? 'Yes' : 'No'}
                  </td>
                  <td className='px-4 py-2'>{record.branch_name || '-'}</td>
                  <td className='px-4 py-2'>{record.ethnicity || '-'}</td>
                 
                  <td className='px-4 py-2'>{record.address_line_1 || '-'}</td>
                  <td className='px-4 py-2'>{record.city || '-'}</td>
                  <td className='px-4 py-2'>
                    {record.postal_code || '-'} {" "}
                    {record.zip_plus_four ? `-${record.zip_plus_four}` : ''}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default MuleSoftTable
